// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>10</span>&nbsp;&nbsp;The Lord shall reign for ever,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;your God, O Zion, throughout all generations.<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Alleluia.<br> </p> </div></div>";
// Exports
module.exports = code;